import React from 'react';
import HeaderBar from '../components/common/stories/HeaderBar';


const Header = () => {

  return (
    <HeaderBar />
  );
};

export default Header;